module.exports = __webpack_public_path__ + "static/media/add-downArrow.e272231b.svg";